<div class="PGResourceViewTable {{!isInitialized ? 'PGResourceViewTable--NotInitialized' : ''}}">
        <div class="PGResourceViewTable-Actions mb-3">
            <div class="d-flex align-items-center">
                @if (countersData) {
                    <div class="ms-2 ps-1 me-1">
                        {{ 'pg-resource-view-table.count' | locTranslate:'count':countersData.count }}
                    </div>
                }
            </div>
            <div class="d-flex align-items-center">
                @if (hasCSVExport()) {
                    <button class="btn btn-sm btn-primary me-1" [disabled]="isExporting" (click)="doCSVExport()">
                        <i class="fa-regular fa-file-csv"></i><span>{{ 'pg-resource-view-table.csv-export' | locTranslate }}</span>
                    </button>
                }

                @if (actions.edit) {
                    @if (hasMassPublish()) {
                        <button class="btn btn-sm btn-primary ms-1" (click)="openMassPublish()">
                            <i class="fa-regular fa-eye"></i><span>{{ 'pg-resource-view-table.mass-publish' | locTranslate }}</span>
                        </button>
                    }
                }
    
                @if (actions.create) {
                    @if (actions.copy) {
                        <app-pg-resource-picker [resourceId]="resourceId" resourceMode="public" customContent="true"
                            selectionMode="single" (selectionClose)="createCopyFrom($event[0])">
                            <button class="btn btn-sm btn-primary ms-1">
                                <i class="fa-regular fa-copy"></i><span>{{ 'pg-resource-view-table.create-copy' | locTranslate }}</span>
                            </button>
                        </app-pg-resource-picker>
                    }
                    @for (draft of unsavedDrafts; track draft) {
                        <button class="btn btn-sm btn-primary ms-1" (click)="resumeDraft(draft.id)">
                            <i class="fa-regular fa-share"></i><span>{{ 'pg-resource-view-table.resume-draft' | locTranslate:'draft':draft.description }}</span>
                        </button>
                    }
                    <button class="btn btn-sm btn-primary ms-1" (click)="createNew()">
                        <i class="fa-regular fa-plus"></i><span>{{ 'pg-resource-view-table.add-resource' | locTranslate }}</span>
                    </button>
                }
            </div>
        </div>
        <div class="PGResourceViewTable-Wrapper">
            <table class="container-fluid">
                <thead class="PGResourceViewTable-Header bg-light PGResourceViewTable-Header--Outer" #tableHeaderOuter>
                    <tr class="row PGResourceViewTable-Header-Row"></tr>
                </thead>
            </table>
            <div class="PGResourceViewTable-Scrollable" #tableScrollable>
                <table class="container-fluid">
                    <thead class="PGResourceViewTable-Header bg-light PGResourceViewTable-Header--Inner" #tableHeaderInner>
                        @if (viewConfig != null) {
                            <tr class="row PGResourceViewTable-Header-Row">
                                <th class="col PGResourceViewTable-Col-Actions"></th>
                                @for (dataCol of columnStatus; track dataCol) {
                                    <th class="col">
                                        <span>
                                            <ng-container>{{(dataCol.label != null ? dataCol.label : dataCol.name) | locTranslate}}</ng-container>
                                            @if (dataCol.filter) {
                                                <small class="text-muted ms-1"><i class="fa-regular fa-filter"></i></small>
                                            }
                                            @if (dataCol.order; as direction;) {
                                                <small class="text-muted ms-1">
                                                    @if (direction == 'asc') {
                                                        <i class="fa-regular fa-chevron-down"></i>
                                                    }
                                                    @if (direction == 'desc') {
                                                        <i class="fa-regular fa-chevron-up"></i>
                                                    }
                                                </small>
                                            }
                                        </span>
                                    </th>
                                }
                                <th class="col PGResourceViewTable-Col-SystemTags"></th>
                                @if (!readOnly) {
                                    <th class="col PGResourceViewTable-Col-Flags"></th>
                                }
                            </tr>
                        }
                    </thead>
                    @for (dataRow of dataRows; track dataRow) {
                        <tbody class="PGResourceViewTable-Body pg-animation-fadein" (click)="onRowClick($event, dataRow);">
                            <tr class="row PGResourceViewTable-Body-Row {{getRowClass(dataRow)}} {{ isSelected(dataRow) ? 'shadow-highlight-inset' : '' }}">
                                <td class="col PGResourceViewTable-Col-Actions">
                                    <div>
                                        @if (!selectionMode) {
                                            <app-pg-resource-element-menu [resourceId]="resourceId" [elementId]="dataRow.id" [elementData]="dataRow" [readOnly]="readOnly" (dataChange)="handleElementChange(dataRow.id, $event)"></app-pg-resource-element-menu>
                                        }
                                        @if (selectionMode) {
                                            <input readonly [type]="selectionMode == 'multi' ? 'checkbox' : 'radio'" [checked]="isSelected(dataRow)">
                                        }
                                    </div>
                                </td>
                                @for (dataCol of columnStatus; track dataCol) {
                                    @if (dataCol.field != null) {
                                        <td class="col PGResourceViewTable-Col-Field {{ getColDataTypeClass(dataCol) }}">
                                            <span locFormat="byConfig" [formatValue]="getFieldValue(dataRow, dataCol.field)" [formatParam]="dataCol.type"></span>
                                        </td>
                                    }
                                    @if (dataCol.roleview != null) {
                                        <td class="col PGResourceViewTable-Col-Roleview">
                                            <span [innerHTML]="getRoleview(dataCol.roleview, dataRow)"></span>
                                        </td>
                                    }
                                    @if (dataCol.cluster != null) {
                                        <td class="col PGResourceViewTable-Col-Cluster">
                                            @for (clusterColumn of getClusterColumns(dataCol.cluster); track clusterColumn) {
                                                @if (dataRow[clusterColumn]) {
                                                    <span locFormat="byConfig" [formatValue]="dataRow[clusterColumn]" [formatParam]="dataCol.types[clusterColumn]"></span>
                                                }
                                            }
                                        </td>
                                    }
                                }
                                <div class="col PGResourceViewTable-Col-SystemTags">
                                    @if (dataRow.system_tags != null) {
                                        <div>
                                            <span class="badge bg-light" title="{{formatSystemTagsLabel(dataRow.system_tags, true)}}">
                                                <i class="fa-regular fa-hashtag-lock"></i><span>{{formatSystemTagsLabel(dataRow.system_tags)}}</span>
                                            </span>
                                        </div>
                                    }
                                </div>
                                @if (!readOnly) {
                                    <td class="col PGResourceViewTable-Col-Flags">
                                        <div class="d-flex align-items-center">
                                            <div class="d-flex align-items-center">
                                                @if (actions.book) {
                                                    <div class="me-3">
                                                        @if (dataRow.bookable) {
                                                            <i class="fa-regular fa-book"></i>
                                                        }
                                                        @if (!dataRow.bookable) {
                                                            <i class="fa-regular fa-book PGSlashedIcon text-muted">
                                                                <i class="fa-regular fa-slash text-white"></i>
                                                                <i class="fa-regular fa-slash"></i>
                                                            </i>
                                                        }
                                                    </div>
                                                }
                                                @if (actions.publish) {
                                                    <div class="me-3">
                                                        @if (dataRow.published) {
                                                            <i class="fa-regular fa-eye"></i>
                                                        }
                                                        @if (!dataRow.published) {
                                                            <i class="fa-regular fa-eye-slash text-muted"></i>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                            <div class="PGResourceViewTable-Col-Flags-Users">
                                                @if (dataRow.user != null) {
                                                    <div class="me-3">
                                                        <small title="{{formatUserLabel(dataRow.user, true)}}">
                                                            <i class="fa-regular fa-user"></i><span>{{formatUserLabel(dataRow.user)}}</span>
                                                        </small>
                                                    </div>
                                                }
                                                @if (dataRow.group_id != null) {
                                                    <div class="me-3">
                                                        <small>
                                                            <i class="fa-regular fa-users"></i><span>{{getGroupLabel(dataRow.group_id)}}</span>
                                                        </small>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </td>
                                }
                            </tr>
                        </tbody>
                    }
                    @if (isAtEnd && hasFooter()) {
                        <tfoot class="PGResourceViewTable-Footer">
                            <tr class="row PGResourceViewTable-Footer-Sums">
                                @if (hasExtendedActions()) {
                                    <td class="col PGResourceViewTable-Col-Actions"></td>
                                }
                                @for (dataCol of columnStatus; track dataCol) {
                                    <td class="col">
                                        @if (dataCol.sum != null) {
                                            <span>
                                                <small>{{ 'pg-resource-view-table.footer-sum' | locTranslate }}</small>
                                                <span locFormat="byConfig" [formatValue]="dataCol.sum" [formatParam]="dataCol.type"></span>
                                            </span>
                                        }
                                    </td>
                                }
                            </tr>
                        </tfoot>
                    }
                </table>
                <div class="PGResourceViewTable-After">
                    <app-pg-view-more [hidden]="isLoadingData || isAtEnd" (viewMore)="loadData()"></app-pg-view-more>
                    @if (isLoadingData) {
                        <div  class="PGResourceViewTable-After-LoadingData {{isLoadingData ? 'PGResourceViewTable-LoadingData--Show' : ''}}">
                            <app-pg-loading></app-pg-loading>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>